module.exports = __webpack_public_path__ + "img/84ne.99de304d.svg";